/* eslint-disable quotes */
/* eslint-disable semi */
import { storeMutations } from '@store/mutations.constants';
import licenseState from './state';

export const state = licenseState;
const mutations = {
  [storeMutations.departmentMutation]: (state, res) => {
    if (res.status === 200) {
      // state.user = res.data.user;
      state.department = res.data.data;
    }
  },
  [storeMutations.setDepartmentMutation]: (state, res) => {
    if (res.status === 200) {
      // state.user = res.data.user;
      state.departments = res.data;
    }
  },
};
export default {...mutations };